declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
import { MaterialsListRequest, MaterialsListController, GenericProcPostRequest, ModuleData, RolesData, AccessRightData, SaveAccessRightRequest, AccessRightsByRoleController, AccessRightsByRoleRequest } from '../../../models/actor/actor';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { AccessRightPipe } from '../../../pipes/actors/actorIdentity.pipes';






@Component({
  selector: 'accessrights',
  templateUrl: './accessrights.component.html',
  styleUrls: [
    './accessrights.component.scss']
  , animations: [routerTransition()]
})

export class AccessRightsComponent implements OnInit {


  public ShowList: boolean = true;
  public ShowList2: boolean = false;
  public isRequesting: boolean = false;
  public searchValue: string;
  public searchText: any;
  public ApiResData: ApiResponseModel;

  CurrentSaveAccessRightRequest: SaveAccessRightRequest;

  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loginservice: LoginService, private tosterservice: NGXToastrService, private filter: AccessRightPipe) { }

  ngOnInit() {

    this.CurrentSaveAccessRightRequest = new SaveAccessRightRequest();

    this.CurrentSaveAccessRightRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetModulesList();
    this.GetRolesData();

  }

  modules: ModuleData[];

  GetModulesListController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.actorservice.generic_proc_post(this.mreq)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          var rawData = this.ApiResData.Result;
          console.log(rawData);
          if (Array.isArray(rawData) && rawData.length > 0 && typeof rawData[0] === 'string') {
            rawData = rawData.join('');
          }
          var parsed = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
          if (Array.isArray(parsed)) {
            this.modules = parsed.map((m: any) => ({
              ModuleName: m.ModuleName || m.modulename || m.moduleName || '',
              ModuleID: m.ModuleID || m.moduleid || m.moduleId || '',
              Description: m.Description || m.description || ''
            }));
          } else if (parsed && typeof parsed === 'object') {
            this.modules = [parsed];
          } else {
            this.modules = [];
          }
          if (this.modules && this.modules.length > 0 && !this.SelectedModuleDetails) {
            this.SelectedModule(this.modules[0]);
          }
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  GetModulesList() {
    this.mreq = new GenericProcPostRequest();
    this.mreq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.mreq.ConditionalOperator = 1002;
    this.mreq.QueryData = "1";
    //http://healins.cloudapp.net/k1newapi/els/1002/1
    //http://healins.cloudapp.net/k1newapi/els/1002/a=123,b=77
    this.GetModulesListController();

  }
  public SelectedModuleId: string;
  mreq: GenericProcPostRequest;
  SelectedModuleDetails: ModuleData;
  SelectedModule(obj: any) {
    var Module: ModuleData = obj;
    if (Module != null) {
      this.SelectedModuleDetails = null;
      this.SelectedModuleDetails = Module;
      this.ShowList = true;
      this.ShowList2 = true;
      this.CurrentAccessRightsByRoleController = null;
      this.LoadAccessRights(this.SelectedModuleDetails.ModuleID);

    }

  }
  rreq: GenericProcPostRequest;
  GetRolesData() {
    this.rreq = new GenericProcPostRequest();
    this.rreq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.rreq.ConditionalOperator = 1005;
    this.rreq.QueryData = "1";
    this.GetRolesListController();
  }
  Roles: RolesData[];
  GetRolesListController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.actorservice.generic_proc_post(this.rreq)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          var rawRoles = this.ApiResData.Result;
          if (Array.isArray(rawRoles) && rawRoles.length > 0 && typeof rawRoles[0] === 'string') {
            rawRoles = rawRoles.join('');
          }
          var parsedRoles = typeof rawRoles === 'string' ? JSON.parse(rawRoles) : rawRoles;
          if (Array.isArray(parsedRoles)) {
            this.Roles = parsedRoles.map((r: any) => ({
              RoleName: r.RoleName || r.rolename || r.roleName || '',
              RoleID: r.RoleID || r.roleid || r.roleId || '',
              Description: r.Description || r.description || ''
            }));
          } else if (parsedRoles && typeof parsedRoles === 'object') {
            this.Roles = [parsedRoles];
          } else {
            this.Roles = [];
          }
          if (this.Roles && this.Roles.length > 0 && !this.SelectedRoleID) {
            this.SelectedRoleID = this.Roles[0].RoleID;
            this.SelectedRoleName = this.Roles[0].RoleName;
            if (this.SelectedModuleDetails) {
              this.LoadAccessRights(this.SelectedModuleDetails.ModuleID);
            }
          }
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  public SelectedRoleID: string;
  public SelectedRoleName: string = '';
  onChange(Event: any) {
    if (Event != null) {
      this.SelectedRoleName = Event;
      var a = this.Roles ? this.Roles.filter(X => X.RoleName === Event) : [];
      if (a.length > 0) {
        this.SelectedRoleID = a[0].RoleID;

        this.pdata = null;
        if (this.SelectedModuleDetails) {
          this.LoadAccessRights(this.SelectedModuleDetails.ModuleID);
        }
      }
    }
  }
  CurrentAccessRightsByRoleController: AccessRightsByRoleController[];
  CurrentAccessRightsByRoleRequest: AccessRightsByRoleRequest;

  LoadAccessRights(MiD: string) {
    this.CurrentAccessRightsByRoleRequest = new AccessRightsByRoleRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentAccessRightsByRoleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentAccessRightsByRoleController;
    this.GetAccessRightsByRoleController(MiD);
  }


  GetAccessRightsByRoleController(Mid: string) {
    this.StartRefreshing();
    //this.spinner.show();
    this.CurrentAccessRightsByRoleRequest.ConditionalOperator = 10;
    this.CurrentAccessRightsByRoleRequest.ModuleID = Mid;
    this.CurrentAccessRightsByRoleRequest.RoleID = this.SelectedRoleID;
    //alert(this.FormattedCode);
    this.actorservice.GetAccessRightsByRoleController(this.CurrentAccessRightsByRoleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          var rawRights = this.ApiResData.Result;
          if (Array.isArray(rawRights) && rawRights.length > 0 && typeof rawRights[0] === 'string') {
            rawRights = rawRights.join('');
          }
          var parsedRights = typeof rawRights === 'string' ? JSON.parse(rawRights) : rawRights;
          if (Array.isArray(parsedRights)) {
            this.CurrentAccessRightsByRoleController = parsedRights.map((item: any) => ({
              ModuleID: item.ModuleID || item.moduleid || item.moduleId || '',
              ROLEMAPPEDID: item.ROLEMAPPEDID || item.rolemappedid || item.roleMappedId || item.RoleID || item.roleid || item.roleId || '',
              FeatureID: item.FeatureID || item.featureid || item.featureId || '',
              FeatureName: item.FeatureName || item.featurename || item.featureName || item.Name || item.name || '',
              FeatureDescription: item.FeatureDescription || item.featuredescription || item.featureDescription || item.Description || item.description || '',
              ModuleName: item.ModuleName || item.modulename || item.moduleName || '',
              HasAccess: item.HasAccess === true || item.HasAccess === 1 || item.HasAccess === '1' || item.HasAccess === 'true' || item.hasaccess === true || item.hasaccess === 1 || item.hasaccess === '1' || item.hasaccess === 'true' || item.hasAccess === true || item.hasAccess === 1 || item.hasAccess === '1' || item.hasAccess === 'true'
            }));
          } else {
            this.CurrentAccessRightsByRoleController = parsedRights;
          }
          this.pdata = this.CurrentAccessRightsByRoleController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          //this.spinner.hide();
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  Acreq: GenericProcPostRequest;
  GetAccessRightsData(MId: string) {
    this.Acreq = new GenericProcPostRequest();
    this.Acreq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.Acreq.ConditionalOperator = 1011;
    this.Acreq.QueryData = this.SelectedRoleID;
    this.pdata = this.AccessRights;
    this.GetAccessRightsListController(MId);
  }
  AccessRights: AccessRightData[];
  AccessRights2: AccessRightData[];
  GetAccessRightsListController(Mid: string) {
    //alert(Mid);
    this.StartRefreshing();
    //this.spinner.show();
    this.actorservice.generic_proc_post(this.Acreq)
      .subscribe((result) => {
        this.ApiResData = result;
        //alert(this.ApiResData.ErrorData);
        if (!this.ApiResData.hasError) {

          //alert(this.ApiResData.Result);
          var rawRights = this.ApiResData.Result;
          this.AccessRights2 = typeof rawRights === 'string' ? JSON.parse(rawRights) : rawRights;
          this.AccessRights = this.AccessRights2.filter(X => X.ModuleID === Mid)
          this.pdata = this.AccessRights;
          //alert(this.pdata.length);
          //alert(this.ApiResData.Result);
          //alert(this.AccessRights.length);
          //this.pdata = this.CurrentStoreLocationMaterialsController;
          //this.spinner.hide();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  pdata: any[];
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentAccessRightsByRoleController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentAccessRightsByRoleController, this.listFilter);
      }
    }
  }

  onSubmit(l: AccessRightData, e) {
    if (e.target.checked) {
      this.CurrentSaveAccessRightRequest.HasAccess = true;
      this.CurrentSaveAccessRightRequest.FeatureID = l.FeatureID;
      this.CurrentSaveAccessRightRequest.ConditionalOperator = 10;
      this.CurrentSaveAccessRightRequest.ModuleID = l.ModuleID;
      this.CurrentSaveAccessRightRequest.RoleID = l.ROLEMAPPEDID || this.SelectedRoleID;
    }
    else if (!e.target.checked) {
      this.CurrentSaveAccessRightRequest.HasAccess = false;
      this.CurrentSaveAccessRightRequest.FeatureID = l.FeatureID;
      this.CurrentSaveAccessRightRequest.ConditionalOperator = 10;
      this.CurrentSaveAccessRightRequest.ModuleID = l.ModuleID;
      this.CurrentSaveAccessRightRequest.RoleID = l.ROLEMAPPEDID || this.SelectedRoleID;
    }

    this.actorservice.x_SaveAccessRight(this.CurrentSaveAccessRightRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result > 0) {
            //this.GetActorEducationInfoController();
            //this.GetResourceIdentificationByDateInfoController();
            // alertFunctions.AlertParam('Saved Successfully.....!');
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            //this.spinner.hide();
            //his.isvisibleendo = true;
            //this.activeModal.close();
            //this.clearData();
            //this.LoadScansData();
            this.stopRefreshing();

          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            // this.spinner.hide();

            this.stopRefreshing();

          }

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            //alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
            alert(this.ApiResData.ErrorData);


          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
            //this.spinner.hide();
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            // this.spinner.hide();


          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
            //this.spinner.hide();
          }
        }
      );


  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


}
